import React, { type PropsWithChildren, type FC , useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import Cookies from "js-cookie";
import { loginApi } from '../api/api';
import { useAppDispatch, useAppSelector } from '../Store/hooks';
import { logoutUser } from '../Slices/userSlice';

const Auth : FC<PropsWithChildren>= ({ children }) => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { user } = useAppSelector(state => state.userSlice);

    const handleCheckSubscription = async () => {
        try {
            const response = await loginApi(user?.msisdn);
        } catch (error: any) {
            if (error?.response?.status == 403) {
                dispatch(logoutUser(null));
                navigate("/");
            }

            else if (error?.response?.data?.error?.status == 0) {
                dispatch(logoutUser(null));
                navigate("/");
            }
            else if (error?.response?.data?.error?.status == 1) {
                dispatch(logoutUser(null));
                navigate("/");
            }
            else {
                console.log("Something Went Wrong!");
            }
        }
    }

    useEffect(() => {
        if (!user) {
            navigate("/");
        }
        else {
            handleCheckSubscription();
        }
    }, []);
    return (
        <>
            {children}
        </>
    )
}

export default Auth